/* Footer accordion — abre em desktop, fecha em mobile */
(function () {
  function handleFooterAccordions() {
    var accordions = document.querySelectorAll('details.footer-accordion');
    if (!accordions.length) return;
    var isDesktop = window.innerWidth >= 750;
    accordions.forEach(function (el) {
      if (isDesktop) {
        el.setAttribute('open', '');
      } else {
        el.removeAttribute('open');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', handleFooterAccordions);
  window.addEventListener('resize', handleFooterAccordions);
})();


/* Thumbnail click → salta diretamente para a imagem sem scroll por todas as intermédias */
(function () {
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.thumbnail-list__item');
    if (!thumb) return;
    var slider = thumb.closest('media-gallery, gallery-viewer, [id^="GalleryViewer"]');
    if (!slider) return;
    var sliderGrid = slider.querySelector('.slider__grid, [id^="Slider-Gallery"]');
    if (!sliderGrid) return;
    // desativa temporariamente o scroll-behavior para o salto ser instantâneo
    sliderGrid.style.scrollBehavior = 'auto';
    setTimeout(function () { sliderGrid.style.scrollBehavior = ''; }, 50);
  }, true);
})();

/* Cartões de produto: corrige o data-id da imagem de cada swatch quando esse id
   não existe entre os slides do carrossel do cartão (mesmo ficheiro, id diferente
   por ter sido atribuído à variante em separado da media geral do produto).
   Sem esta correção, o clique no swatch não muda a imagem (fica sempre na primeira). */
(function () {
  function filename(src) {
    if (!src) return '';
    return src.split('?')[0].split('/').pop().toLowerCase();
  }

  function collectSlides(card) {
    var slides = [];
    var template = card.querySelector('.all-product-card-images-template');
    if (template && template.content) {
      template.content.querySelectorAll('li[data-id]').forEach(function (li) {
        slides.push(li);
      });
    }
    var firstSlide = card.querySelector('#card__product-image--1');
    if (firstSlide) slides.push(firstSlide);
    return slides;
  }

  function fixSwatch(swatch, slides) {
    var nodeHtml = swatch.getAttribute('data-first-media-node');
    if (!nodeHtml) return;

    var temp = document.createElement('div');
    temp.innerHTML = nodeHtml;
    var img = temp.querySelector('img');
    if (!img) return;

    var currentId = img.getAttribute('data-id');
    var hasMatch = slides.some(function (slide) {
      return slide.getAttribute('data-id') === currentId;
    });
    if (hasMatch) return;

    var wantedFilename = filename(img.getAttribute('src'));
    if (!wantedFilename) return;

    var matchingSlide = slides.find(function (slide) {
      var slideImg = slide.querySelector('img');
      return slideImg && filename(slideImg.getAttribute('src')) === wantedFilename;
    });
    if (!matchingSlide) return;

    var correctId = matchingSlide.getAttribute('data-id');
    if (!correctId || correctId === currentId) return;

    img.setAttribute('data-id', correctId);
    swatch.setAttribute('data-first-media-node', temp.innerHTML);
  }

  function fixCard(card) {
    var slides = collectSlides(card);
    if (!slides.length) return;
    card.querySelectorAll('color-swatch[data-first-media-node]').forEach(function (swatch) {
      fixSwatch(swatch, slides);
    });
  }

  function run() {
    document.querySelectorAll('.card').forEach(fixCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();